import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Spinner } from '../Spinner/Spinner';
import { LoadingLayout } from '../LoadingLayout';
import './LoginPrompt.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { isInAppBrowser } from '../../utils/browserDetection';

function LoginPrompt() {
  const location = useLocation();
  const navigate = useNavigate();
  const { signInWithGoogle, user, isAuthenticating, loading } = useAuth();
  const [isAuthInProgress, setIsAuthInProgress] = useState(
    sessionStorage.getItem('googleAuthInProgress') === 'true'
  );
  const inAppBrowser = isInAppBrowser();

  useEffect(() => {
    if (user) {
      sessionStorage.removeItem('googleAuthInProgress');
      const returnTo = localStorage.getItem('returnTo');
      
      if (returnTo) {
        localStorage.removeItem('returnTo');
        try {
          const url = new URL(returnTo);
          navigate(url.pathname + url.search, { replace: true });
        } catch (e) {
          navigate('/popular', { replace: true });
        }
      } else {
        navigate('/popular', { replace: true });
      }
    }
  }, [user, navigate]);

  const handleGoogleSignIn = async () => {
    setIsAuthInProgress(true);
    sessionStorage.setItem('googleAuthInProgress', 'true');
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error('Google sign in error:', error);
      sessionStorage.removeItem('googleAuthInProgress');
      setIsAuthInProgress(false);
    }
  };

  if (loading) return <LoadingLayout />;

  if (user) return null;

  return (
    <div className="login-prompt">
      {inAppBrowser ? (
        <div className="in-app-browser-warning">
          <h2>Please Open in Browser</h2>
          <p>
            For security reasons, you'll need to open this app in your default web browser 
            (Safari, Chrome, etc.) to log in with Google.
          </p>
          <p>
            Please copy this URL and open it in your browser:
            <br />
            <code>{window.location.href}</code>
          </p>
        </div>
      ) : (
        <div className="login-content">
          <img src="/images/strawberry-filled_logo.png" alt="Logo" className="logo" />
          <div className="login-buttons">
            <button 
              onClick={handleGoogleSignIn} 
              className="google-button"
              disabled={isAuthInProgress || isAuthenticating}
            >
              {isAuthInProgress || isAuthenticating ? (
                <>
                  <Spinner size="small" />
                  Loggar in...
                </>
              ) : (
                <>
                  <i className="fab fa-google"></i>
                  Logga in med Google
                </>
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default LoginPrompt; 